module.exports = __webpack_public_path__ + "img/add-contact-small-black.4b1a90b6.svg";